import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './styles/theme'; // Import your custom theme
import { LabelsProvider } from './context/LabelsContext'; // Import LabelsProvider

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LabelsProvider>
        <App />
      </LabelsProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);